var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#C7D0DB",
    strokeOpacity: 0.501961,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6412 19.9993C27.6412 20.2266 27.551 20.4445 27.3903 20.6052C27.2296 20.7659 27.0116 20.8562 26.7843 20.8562H16.2869L19.966 24.5346C20.127 24.6956 20.2174 24.9139 20.2174 25.1416C20.2174 25.3692 20.127 25.5876 19.966 25.7486C19.805 25.9096 19.5867 26 19.359 26C19.1313 26 18.913 25.9096 18.752 25.7486L13.6104 20.607C13.5306 20.5274 13.4672 20.4328 13.4239 20.3286C13.3807 20.2245 13.3584 20.1128 13.3584 20C13.3584 19.8872 13.3807 19.7755 13.4239 19.6714C13.4672 19.5672 13.5306 19.4726 13.6104 19.393L18.752 14.2514C18.8317 14.1717 18.9264 14.1085 19.0305 14.0653C19.1347 14.0222 19.2463 14 19.359 14C19.4717 14 19.5834 14.0222 19.6875 14.0653C19.7917 14.1085 19.8863 14.1717 19.966 14.2514C20.0457 14.3311 20.1089 14.4258 20.1521 14.5299C20.1952 14.6341 20.2174 14.7457 20.2174 14.8584C20.2174 14.9711 20.1952 15.0828 20.1521 15.1869C20.1089 15.2911 20.0457 15.3857 19.966 15.4654L16.2869 19.1424H26.7843C27.0116 19.1424 27.2296 19.2326 27.3903 19.3933C27.551 19.554 27.6412 19.772 27.6412 19.9993Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.76c72f226bf8c29eb13f21b8b9022c08.svg";
export { ForwardRef as ReactComponent };